import React, { createContext, useState } from 'react'

export const BudgetContext = createContext({})

export const BudgetProvider = (props) => {
  const { budget } = props
  const { selected } = budget

  const [selectedTab, setSelectedTab] = useState(selected)
  const [loading, setLoading] = useState(false)
  const state = { selectedTab, loading, ...props }
  const actions = { setSelectedTab, setLoading }

  return (
    <BudgetContext.Provider value={{ state, actions }}>
      {props.children}
    </BudgetContext.Provider>
  )
}
